module.exports = __webpack_public_path__ + "img/CY.344f9d66.png";